import React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Popover from "@material-ui/core/Popover";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import Select from "@material-ui/core/Select";

import Search from "@material-ui/icons/Search";
import Delete from "@material-ui/icons/Delete";
import Add from "@material-ui/icons/Add";
import Remove from "@material-ui/icons/Remove";
import MoreVert from "@material-ui/icons/MoreVert";
import Info from "@material-ui/icons/InfoOutlined";
import ArrowBack from "@material-ui/icons/ArrowBack";
import CheckCircle from "@material-ui/icons/CheckCircle";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const GRAPHQL_URL = (process.env.REACT_APP_API_URL || "http://localhost:5001") + "/graphql";

const STORE_INFO = {
  name: "BẾP NHÀ KIM",
  tagline: "MÓN NGON NHÀ LÀM",
  fb: "KIM UNU - 0903.124.581",
  zaloMomo: "0903.124.581",
  thankYou: "Cảm ơn bạn đã ủng hộ Kim! Hẹn gặp lại ^_^",
};

const VN_BANKS = [
  "Vietcombank", "Techcombank", "BIDV", "VietinBank", "MB Bank",
  "ACB", "Sacombank", "VPBank", "TPBank", "SHB", "HDBank", "OCB",
  "SeABank", "VIB", "Agribank", "Eximbank", "MSB", "NamABank",
  "BaoVietBank", "PVcomBank", "LienVietPostBank",
];

const PLACEHOLDER_COLORS = [
  "#ffcdd2", "#f8bbd0", "#e1bee7", "#c5cae9",
  "#b3e5fc", "#b2dfdb", "#dcedc8", "#ffe0b2",
];

const useStyles = makeStyles(styles);
const useCustom = makeStyles({
  stepContent: { padding: "16px 0", minHeight: "400px" },
  searchBox: {
    display: "flex", alignItems: "center", border: "1px solid #ccc",
    borderRadius: "4px", padding: "4px 10px", backgroundColor: "#fff",
    height: "36px", flex: 1, maxWidth: "400px",
  },
  customerResult: {
    padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid #f0f0f0",
    "&:hover": { backgroundColor: "#f5f5f5" },
    display: "flex", justifyContent: "space-between", alignItems: "center",
  },
  debtBadge: {
    display: "inline-block", padding: "2px 8px", borderRadius: "12px",
    fontSize: "11px", fontWeight: 700, backgroundColor: "#fce4ec", color: "#b71c1c",
    marginLeft: "8px",
  },
  selectedCustomer: {
    display: "flex", alignItems: "center", gap: "10px",
    padding: "8px 12px", backgroundColor: "#e3f2fd", borderRadius: "6px",
    marginBottom: "12px",
  },
  productCard: {
    display: "flex", flexDirection: "column", alignItems: "center",
    padding: "10px 8px", borderRadius: "8px", cursor: "pointer",
    border: "2px solid transparent", transition: "all 0.15s",
    position: "relative", userSelect: "none",
  },
  productCardSelected: {
    border: "2px solid #1976d2", backgroundColor: "#e3f2fd",
  },
  productImg: {
    width: "56px", height: "56px", borderRadius: "8px",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: "20px", marginBottom: "6px", flexShrink: 0,
  },
  productName: { fontSize: "11px", fontWeight: 600, textAlign: "center", lineHeight: 1.3, color: "#333" },
  productPrice: { fontSize: "13px", fontWeight: 700, color: "#1565c0", marginTop: "4px" },
  qtyBadge: {
    position: "absolute", top: "4px", right: "4px", width: "20px", height: "20px",
    borderRadius: "50%", backgroundColor: "#1976d2", color: "#fff",
    fontSize: "11px", display: "flex", alignItems: "center", justifyContent: "center",
    fontWeight: 700,
  },
  lineRow: {
    display: "flex", alignItems: "flex-start", padding: "10px 12px",
    borderBottom: "1px solid #f0f0f0", gap: "10px",
  },
  lineNum: { color: "#999", fontSize: "12px", minWidth: "20px", paddingTop: "4px" },
  lineMeta: { flex: 1, minWidth: 0 },
  lineCode: { fontSize: "11px", color: "#888" },
  lineName: { fontSize: "13px", fontWeight: 600, color: "#222" },
  qtyStepper: {
    display: "flex", alignItems: "center", gap: "4px", marginTop: "6px",
  },
  qtyBtn: {
    width: "26px", height: "26px", borderRadius: "50%", border: "1px solid #ccc",
    display: "flex", alignItems: "center", justifyContent: "center",
    cursor: "pointer", backgroundColor: "#fff", fontSize: "16px", userSelect: "none",
    "&:hover": { backgroundColor: "#e3f2fd" },
  },
  qtyInput: {
    width: "36px", textAlign: "center", border: "none", fontSize: "14px",
    fontWeight: 600, outline: "none",
  },
  priceCol: { textAlign: "right", minWidth: "80px" },
  totalCol: { textAlign: "right", minWidth: "80px", fontWeight: 700 },
  summaryRow: {
    display: "flex", justifyContent: "space-between", padding: "6px 0",
    fontSize: "14px", borderBottom: "1px solid #f5f5f5",
  },
  summaryTotal: {
    display: "flex", justifyContent: "space-between", padding: "8px 0",
    fontSize: "16px", fontWeight: 700, color: "#1565c0",
  },
  payMethod: { display: "flex", gap: "8px", flexWrap: "wrap", margin: "8px 0" },
  quickAmounts: {
    display: "flex", flexWrap: "wrap", gap: "8px", margin: "10px 0",
  },
  quickBtn: {
    padding: "6px 14px", borderRadius: "20px", border: "1px solid #ccc",
    cursor: "pointer", fontSize: "13px", backgroundColor: "#fff",
    "&:hover": { backgroundColor: "#e3f2fd", borderColor: "#1976d2" },
  },
  categoryTabs: {
    display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "10px",
  },
  catTab: {
    padding: "4px 12px", borderRadius: "16px", fontSize: "12px",
    border: "1px solid #ddd", cursor: "pointer", backgroundColor: "#fff",
    fontWeight: 500,
  },
  catTabActive: {
    backgroundColor: "#1976d2", color: "#fff", borderColor: "#1976d2",
  },
  pricePopover: { padding: "14px 16px", minWidth: "220px" },
  priceLabel: { fontSize: "12px", color: "#888", marginBottom: "2px" },
  priceInput: {
    border: "none", borderBottom: "1px solid #ccc", fontSize: "14px",
    outline: "none", width: "100%", padding: "2px 0",
  },
  discountToggle: {
    display: "flex", border: "1px solid #1976d2", borderRadius: "4px",
    overflow: "hidden", marginLeft: "6px",
  },
  discountToggleBtn: {
    padding: "2px 8px", fontSize: "12px", cursor: "pointer", fontWeight: 600,
    backgroundColor: "#fff", color: "#1976d2",
  },
  discountToggleBtnActive: {
    backgroundColor: "#1976d2", color: "#fff",
  },
  noteInput: {
    width: "100%", border: "1px solid #ccc", borderRadius: "4px",
    padding: "6px 8px", fontSize: "13px", resize: "vertical", minHeight: "60px",
    outline: "none", fontFamily: "inherit",
  },
  amountInput: {
    border: "1px solid #ccc", borderRadius: "4px", padding: "6px 10px",
    fontSize: "16px", fontWeight: 600, textAlign: "right", outline: "none",
    width: "100%", boxSizing: "border-box",
  },
  navBtns: { display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "16px" },
});

function gql(query, variables) {
  const token = localStorage.getItem("token");
  return fetch(GRAPHQL_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: token ? `Bearer ${token}` : "" },
    credentials: "include",
    body: JSON.stringify({ query, variables }),
  }).then((r) => r.json());
}

function formatNum(val) {
  return Number(val || 0).toLocaleString("vi-VN");
}

function printInvoice(invoice, customer, lines) {
  const w = window.open("", "_blank");
  const pad = (n) => String(n).padStart(2, "0");
  const fmtDate = (d) => {
    const dt = new Date(d);
    return `Ngày ${pad(dt.getDate())} tháng ${pad(dt.getMonth() + 1)} năm ${dt.getFullYear()}`;
  };
  const fmtNum = (n) => Number(n || 0).toLocaleString("vi-VN");

  const linesHtml = lines
    .map(
      (l, i) => `
    <tr>
      <td style="padding:4px 0;border-bottom:1px dashed #ccc">${i + 1}/ ${l.productName}</td>
      <td style="text-align:right;border-bottom:1px dashed #ccc">${fmtNum(l.salePrice)}</td>
      <td style="text-align:right;border-bottom:1px dashed #ccc">${l.quantity}</td>
      <td style="text-align:right;border-bottom:1px dashed #ccc">${fmtNum(l.total)}</td>
    </tr>`
    )
    .join("");

  w.document.write(`<!DOCTYPE html>
<html><head><meta charset="UTF-8"><style>
  body{font-family:Arial,sans-serif;font-size:13px;max-width:680px;margin:20px auto;color:#000}
  .center{text-align:center} .bold{font-weight:bold}
  h2{color:#1565c0;margin:4px 0} h3{color:#e65100;margin:4px 0}
  table{width:100%;border-collapse:collapse;margin:10px 0}
  th{border-top:1px solid #000;border-bottom:1px solid #000;padding:4px 0;font-size:12px}
  .total-row td{font-weight:bold;padding:3px 0}
  @media print{button{display:none}}
</style></head>
<body>
  <div class="center bold" style="font-size:18px;color:#1565c0">${STORE_INFO.name}</div>
  <div class="center" style="font-size:12px">${STORE_INFO.tagline}</div>
  <div class="center" style="font-size:12px">FB: ${STORE_INFO.fb}</div>
  <h3 class="center">HÓA ĐƠN BÁN HÀNG</h3>
  <div class="center" style="color:#e65100">Số HĐ: ${invoice.invoiceNumber}</div>
  <div class="center" style="color:#e65100">${fmtDate(invoice.invoiceDate || new Date())}</div>
  <br>
  ${customer ? `<div>Khách hàng: ${customer.name}</div>${customer.phone1 ? `<div>SĐT: ${customer.phone1}</div>` : ""}${customer.address ? `<div>Địa chỉ: ${customer.address}</div>` : ""}` : ""}
  <table>
    <tr>
      <th style="text-align:left">Đơn giá</th>
      <th style="text-align:right;width:50px">SL</th>
      <th style="text-align:right">Thành tiền</th>
    </tr>
    ${linesHtml}
    <tr class="total-row"><td>Tổng tiền hàng:</td><td></td><td style="text-align:right">${fmtNum(invoice.subtotal)}</td></tr>
    ${invoice.discount ? `<tr><td>Giảm giá:</td><td></td><td style="text-align:right">-${fmtNum(invoice.discount)}</td></tr>` : ""}
    ${invoice.surcharges ? `<tr><td>Phụ thu:</td><td></td><td style="text-align:right">+${fmtNum(invoice.surcharges)}</td></tr>` : ""}
    ${invoice.deliveryFee ? `<tr><td>Phí vận chuyển:</td><td></td><td style="text-align:right">+${fmtNum(invoice.deliveryFee)}</td></tr>` : ""}
    <tr class="total-row"><td>Tổng thanh toán:</td><td></td><td style="text-align:right">${fmtNum(invoice.total)}</td></tr>
  </table>
  ${invoice.note ? `<div style="margin-top:8px;font-style:italic;font-size:12px">Ghi chú: ${invoice.note}</div>` : ""}
  <div class="center" style="margin-top:16px">ZALO/MOMO ${STORE_INFO.zaloMomo}</div>
  <div class="center" style="font-style:italic">${STORE_INFO.thankYou}</div>
</body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 600);
}

// ── Sub-components ──────────────────────────────────────────────────────────

function ProductImgPlaceholder({ product, size = 56 }) {
  const idx = product.id ? parseInt(product.id, 10) % PLACEHOLDER_COLORS.length : 0;
  const bg = PLACEHOLDER_COLORS[idx];
  return (
    <div style={{
      width: size, height: size, borderRadius: "8px", backgroundColor: bg,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: size * 0.4, flexShrink: 0,
    }}>
      🛍
    </div>
  );
}

function LatestPricesModal({ open, onClose, customerId, productId, productName }) {
  const [prices, setPrices] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!open || !customerId || !productId) return;
    setLoading(true);
    gql(`query Q($cid:String!,$pid:String!){getProductLatestSalePrices(customerId:$cid,productId:$pid){invoiceNumber invoiceDate salePrice quantity discountPercent}}`,
      { cid: customerId, pid: productId })
      .then(({ data }) => setPrices(data?.getProductLatestSalePrices || []))
      .finally(() => setLoading(false));
  }, [open, customerId, productId]);

  const pad = (n) => String(n).padStart(2, "0");
  const fmtDate = (d) => {
    const dt = new Date(d);
    return `${pad(dt.getDate())}/${pad(dt.getMonth() + 1)}/${dt.getFullYear()}`;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Latest sale prices — {productName}</DialogTitle>
      <DialogContent>
        {loading ? <CircularProgress size={24} /> : prices.length === 0 ? (
          <p style={{ color: "#999", textAlign: "center" }}>No previous sales to this customer</p>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #eee" }}>
                <th style={{ textAlign: "left", padding: "4px 0" }}>Invoice</th>
                <th style={{ textAlign: "left" }}>Date</th>
                <th style={{ textAlign: "right" }}>Qty</th>
                <th style={{ textAlign: "right" }}>Sale price</th>
                <th style={{ textAlign: "right" }}>Discount %</th>
              </tr>
            </thead>
            <tbody>
              {prices.map((p, i) => (
                <tr key={i} style={{ borderBottom: "1px solid #f5f5f5" }}>
                  <td style={{ padding: "6px 0", fontWeight: 600, color: "#1565c0" }}>{p.invoiceNumber}</td>
                  <td>{fmtDate(p.invoiceDate)}</td>
                  <td style={{ textAlign: "right" }}>{p.quantity}</td>
                  <td style={{ textAlign: "right", fontWeight: 600 }}>{formatNum(p.salePrice)}</td>
                  <td style={{ textAlign: "right" }}>{p.discountPercent || 0}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </DialogContent>
      <DialogActions>
        <button onClick={onClose} style={{ padding: "6px 16px", cursor: "pointer" }}>Close</button>
      </DialogActions>
    </Dialog>
  );
}

function NoteModal({ open, onClose, note, onChange }) {
  const [val, setVal] = React.useState(note || "");
  React.useEffect(() => { if (open) setVal(note || ""); }, [open, note]);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Note for product</DialogTitle>
      <DialogContent>
        <textarea
          style={{ width: "100%", border: "1px solid #ccc", borderRadius: "4px", padding: "8px", fontSize: "13px", minHeight: "80px", resize: "vertical", fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
          value={val}
          onChange={(e) => setVal(e.target.value)}
          placeholder="Enter product note..."
        />
      </DialogContent>
      <DialogActions>
        <button onClick={onClose} style={{ padding: "6px 16px", cursor: "pointer" }}>Cancel</button>
        <button onClick={() => { onChange(val); onClose(); }}
          style={{ padding: "6px 16px", cursor: "pointer", backgroundColor: "#1976d2", color: "#fff", border: "none", borderRadius: "4px" }}>
          Save
        </button>
      </DialogActions>
    </Dialog>
  );
}

function PricePopover({ anchorEl, onClose, line, onChange }) {
  const [discMode, setDiscMode] = React.useState("VND"); // VND or %
  const costPrice = line?.product?.costPrice || 0;
  const listPrice = line?.price || 0;
  const salePrice = line?.salePrice || 0;
  const aboveCost = costPrice > 0 && salePrice > costPrice;
  const atZero = salePrice <= 0;
  const hasError = aboveCost || atZero;

  if (!line) return null;

  const applyNewSalePrice = (sp) => {
    const min = 1;
    const max = costPrice > 0 ? costPrice : Infinity;
    const clamped = Math.min(Math.max(sp, min), max);
    onChange({
      salePrice: clamped,
      discount: costPrice - clamped > 0 ? costPrice - clamped : 0,
      discountPercent: costPrice > 0 ? Math.round(((costPrice - clamped) / costPrice) * 10000) / 100 : 0,
    });
  };

  const handleDiscountChange = (val) => {
    const raw = parseFloat(val) || 0;
    let newSalePrice;
    if (discMode === "%") {
      const discAmt = Math.round((costPrice * raw) / 100);
      newSalePrice = costPrice - discAmt;
    } else {
      newSalePrice = costPrice - raw;
    }
    applyNewSalePrice(newSalePrice);
  };

  const handleSalePriceChange = (val) => {
    applyNewSalePrice(parseFloat(val) || 0);
  };

  return (
    <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}>
      <div style={{ padding: "14px 16px", minWidth: "230px" }}>
        <div style={{ fontSize: "12px", color: "#888", marginBottom: "2px" }}>List price</div>
        <div style={{ fontSize: "14px", fontWeight: 600, marginBottom: "4px" }}>{formatNum(listPrice)}</div>
        <div style={{ fontSize: "12px", color: "#888", marginBottom: "2px" }}>Cost price (max)</div>
        <div style={{ fontSize: "14px", fontWeight: 600, color: "#1565c0", marginBottom: "10px" }}>{formatNum(costPrice)}</div>

        <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
          <div style={{ fontSize: "12px", color: "#888", marginRight: "8px", minWidth: "60px" }}>Discount</div>
          <input type="number" min="0"
            style={{ flex: 1, border: "none", borderBottom: "1px solid #1976d2", outline: "none", fontSize: "14px", padding: "2px 0", textAlign: "right" }}
            value={discMode === "%" ? (line.discountPercent || 0) : (line.discount || 0)}
            onChange={(e) => handleDiscountChange(e.target.value)} />
          <div style={{ display: "flex", border: "1px solid #1976d2", borderRadius: "4px", overflow: "hidden", marginLeft: "6px" }}>
            {["VND", "%"].map((m) => (
              <div key={m} onClick={() => setDiscMode(m)}
                style={{ padding: "2px 7px", fontSize: "12px", cursor: "pointer", fontWeight: 600,
                  backgroundColor: discMode === m ? "#1976d2" : "#fff",
                  color: discMode === m ? "#fff" : "#1976d2" }}>
                {m}
              </div>
            ))}
          </div>
        </div>

        <div style={{ fontSize: "12px", color: "#888", marginBottom: "2px" }}>Sale price</div>
        <input type="number" min="1" max={costPrice || undefined}
          style={{ width: "100%", border: "none", borderBottom: `1px solid ${hasError ? "#ef5350" : "#ccc"}`, outline: "none", fontSize: "14px", padding: "2px 0", textAlign: "right", boxSizing: "border-box" }}
          value={salePrice}
          onChange={(e) => handleSalePriceChange(e.target.value)} />
        {aboveCost && (
          <div style={{ fontSize: "11px", color: "#ef5350", marginTop: "4px" }}>
            ⚠ Cannot exceed cost price ({formatNum(costPrice)})
          </div>
        )}
        {atZero && !aboveCost && (
          <div style={{ fontSize: "11px", color: "#ef5350", marginTop: "4px" }}>
            ⚠ Must be greater than 0
          </div>
        )}
      </div>
    </Popover>
  );
}

function ProductLineItem({ line, index, customerId, onQtyChange, onLineChange, onRemove, classes }) {
  const custom = useCustom();
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const [priceAnchor, setPriceAnchor] = React.useState(null);
  const [showLatestPrices, setShowLatestPrices] = React.useState(false);
  const [showNote, setShowNote] = React.useState(false);
  const [showTooltip, setShowTooltip] = React.useState(false);

  const total = (line.qty || 1) * (line.salePrice || 0);

  return (
    <div className={custom.lineRow}>
      {/* Delete */}
      <IconButton size="small" onClick={onRemove} style={{ color: "#ef5350", marginTop: "2px" }}>
        <Delete fontSize="small" />
      </IconButton>

      {/* Line number */}
      <div className={custom.lineNum}>{index + 1}</div>

      {/* Product info */}
      <div className={custom.lineMeta}>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span className={custom.lineCode}>{line.product.productNumber}</span>
          <span className={custom.lineName}>{line.product.name}</span>
          <Tooltip
            open={showTooltip}
            onOpen={() => setShowTooltip(true)}
            onClose={() => setShowTooltip(false)}
            title={
              <div style={{ fontSize: "12px" }}>
                <div>On hand: {line.product.onHand ?? 0}</div>
                <div>Ordered: {line.product.customerOrdered ?? 0}</div>
              </div>
            }>
            <Info fontSize="small" style={{ color: "#90a4ae", cursor: "pointer" }}
              onClick={() => setShowTooltip(!showTooltip)} />
          </Tooltip>
        </div>

        {/* Qty stepper */}
        <div className={custom.qtyStepper}>
          <div className={custom.qtyBtn} onClick={() => onQtyChange(Math.max(1, (line.qty || 1) - 1))}>−</div>
          <input type="number" className={custom.qtyInput} value={line.qty || 1}
            onChange={(e) => onQtyChange(Math.max(1, parseInt(e.target.value) || 1))} />
          <div className={custom.qtyBtn} onClick={() => onQtyChange((line.qty || 1) + 1)}>+</div>
        </div>

        {/* Note badge */}
        {line.productNote && (
          <div style={{ fontSize: "11px", color: "#888", marginTop: "4px", fontStyle: "italic" }}>
            📝 {line.productNote}
          </div>
        )}
      </div>

      {/* Price */}
      <div style={{ textAlign: "right", minWidth: "80px" }}>
        <div style={{ fontSize: "13px", color: "#555" }}>{formatNum(line.salePrice)}</div>
        {line.discountPercent > 0 && (
          <div style={{ fontSize: "11px", color: "#ef5350" }}>-{line.discountPercent}%</div>
        )}
      </div>

      {/* Total */}
      <div style={{ textAlign: "right", minWidth: "80px", fontWeight: 700, fontSize: "14px" }}>
        {formatNum(total)}
      </div>

      {/* Price edit button */}
      <IconButton size="small" onClick={(e) => setPriceAnchor(e.currentTarget)} style={{ marginTop: "2px" }}>
        <span style={{ fontSize: "11px", color: "#1976d2", whiteSpace: "nowrap" }}>Edit</span>
      </IconButton>

      {/* Three-dot menu */}
      <IconButton size="small" onClick={(e) => setMenuAnchor(e.currentTarget)} style={{ marginTop: "2px" }}>
        <MoreVert fontSize="small" />
      </IconButton>

      <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
        <MenuItem onClick={() => { setMenuAnchor(null); setShowLatestPrices(true); }}
          disabled={!customerId}>
          📈 View latest sale prices
        </MenuItem>
        <MenuItem onClick={() => { setMenuAnchor(null); setShowNote(true); }}>
          ✏️ Note
        </MenuItem>
      </Menu>

      <PricePopover anchorEl={priceAnchor} onClose={() => setPriceAnchor(null)}
        line={line} onChange={(updates) => { onLineChange(updates); setPriceAnchor(null); }} />

      <LatestPricesModal open={showLatestPrices} onClose={() => setShowLatestPrices(false)}
        customerId={customerId} productId={line.product.id} productName={line.product.name} />

      <NoteModal open={showNote} onClose={() => setShowNote(false)}
        note={line.productNote} onChange={(note) => onLineChange({ productNote: note })} />
    </div>
  );
}

// ── Main Page ────────────────────────────────────────────────────────────────

export default function NewInvoicePage() {
  const classes = useStyles();
  const custom = useCustom();
  const history = useHistory();
  const location = useLocation();
  const { id: draftId } = useParams();

  const [step, setStep] = React.useState(0);
  const [draftLoading, setDraftLoading] = React.useState(!!draftId);

  // Step 1: customer
  const [customerSearch, setCustomerSearch] = React.useState("");
  const [customerResults, setCustomerResults] = React.useState([]);
  const [customer, setCustomer] = React.useState(null);
  const [showCustDrop, setShowCustDrop] = React.useState(false);
  const custDebounce = React.useRef(null);

  // Step 1: products
  const [productSearch, setProductSearch] = React.useState("");
  const [categories, setCategories] = React.useState([]);
  const [categoryId, setCategoryId] = React.useState("");
  const [productResults, setProductResults] = React.useState([]);
  const [productLoading, setProductLoading] = React.useState(false);
  const prodDebounce = React.useRef(null);

  // Selected lines: [{product, qty, salePrice, price, discountPercent, discount, productNote}]
  const [lines, setLines] = React.useState([]);

  // Step 3 delivery
  const [isDelivery, setIsDelivery] = React.useState(false);
  const [receiverName, setReceiverName] = React.useState("");
  const [receiverPhone, setReceiverPhone] = React.useState("");
  const [receiverAddress, setReceiverAddress] = React.useState("");
  const [receiverProvince, setReceiverProvince] = React.useState("");
  const [receiverWard, setReceiverWard] = React.useState("");
  const [carrier, setCarrier] = React.useState("");
  const [carrierPhone, setCarrierPhone] = React.useState("");
  const [packages, setPackages] = React.useState(1);
  const [weightGrams, setWeightGrams] = React.useState(500);
  const [dimL, setDimL] = React.useState(1);
  const [dimW, setDimW] = React.useState(1);
  const [dimH, setDimH] = React.useState(1);
  const [courierNote, setCourierNote] = React.useState("");

  // Step 4 payment
  const [payMethod, setPayMethod] = React.useState("cash");
  const [bankDialogOpen, setBankDialogOpen] = React.useState(false);
  const [bankForm, setBankForm] = React.useState({ bank: "", bankAccountNumber: "" });
  const [bankSaving, setBankSaving] = React.useState(false);
  const [invoiceDiscount, setInvoiceDiscount] = React.useState(0);
  const [surcharge, setSurcharge] = React.useState(0);
  const [shippingCost, setShippingCost] = React.useState(0);
  const [invoiceNote, setInvoiceNote] = React.useState("");
  const [customerPay, setCustomerPay] = React.useState(0);

  // Submit state
  const [submitting, setSubmitting] = React.useState(false);
  const [successMsg, setSuccessMsg] = React.useState("");
  const [completed, setCompleted] = React.useState(false);

  // Draft dialog
  const [draftDialogOpen, setDraftDialogOpen] = React.useState(false);
  const [pendingLocation, setPendingLocation] = React.useState(null);
  const [draftSaving, setDraftSaving] = React.useState(false);
  const unblockRef = React.useRef(null);

  const isDirty = lines.length > 0 && !completed;

  // Block navigation when dirty
  React.useEffect(() => {
    if (!isDirty) {
      if (unblockRef.current) { unblockRef.current(); unblockRef.current = null; }
      return;
    }
    unblockRef.current = history.block((location) => {
      setPendingLocation(typeof location === "string" ? location : location.pathname);
      setDraftDialogOpen(true);
      return false;
    });
    return () => { if (unblockRef.current) { unblockRef.current(); unblockRef.current = null; } };
  }, [isDirty, history]);

  const doNavigate = React.useCallback(() => {
    if (unblockRef.current) { unblockRef.current(); unblockRef.current = null; }
    setDraftDialogOpen(false);
    history.push(pendingLocation || "/admin/invoices");
  }, [history, pendingLocation]);

  const handleSaveDraft = async () => {
    setDraftSaving(true);
    try {
      const draftTotal = Math.max(0, subtotal - (invoiceDiscount || 0) + (surcharge || 0) + (shippingCost || 0));
      const input = {
        customerId: customer?.id || undefined,
        subtotal,
        discount: invoiceDiscount || 0,
        surcharges: surcharge || 0,
        deliveryFee: shippingCost || 0,
        total: draftTotal,
        paid: 0,
        status: "Draft",
        note: invoiceNote || undefined,
        // Delivery info
        ...(isDelivery ? {
          carrier: carrier || undefined,
          deliveryNote: courierNote || undefined,
          receiverName: receiverName || undefined,
          receiverPhone: receiverPhone || undefined,
          receiverAddress: receiverAddress || undefined,
          receiverProvince: receiverProvince || undefined,
          receiverWard: receiverWard || undefined,
          weight: weightGrams ? weightGrams / 1000 : undefined,
          length: dimL || undefined,
          width: dimW || undefined,
          height: dimH || undefined,
        } : {}),
        lines: lines.map((l) => ({
          productId: l.product.id?.startsWith?.("manual-") ? undefined : l.product.id,
          productNumber: l.product.productNumber,
          productName: l.product.name,
          barcode: l.product.barcode,
          brand: l.product.brand?.name,
          unit: l.product.unit,
          productNote: l.productNote || undefined,
          quantity: l.qty,
          price: l.price,
          discountPercent: l.discountPercent || 0,
          discount: l.discount || 0,
          salePrice: l.salePrice,
          total: l.qty * l.salePrice,
        })),
      };
      const { errors } = draftId
        ? await gql(
            `mutation M($id:String!,$input:CreateInvoiceDto!){updateDraftInvoice(id:$id,input:$input){id}}`,
            { id: draftId, input }
          )
        : await gql(
            `mutation M($input:CreateInvoiceDto!){createInvoice(input:$input){id}}`,
            { input }
          );
      if (errors) { alert(errors[0].message); return; }
      if (unblockRef.current) { unblockRef.current(); unblockRef.current = null; }
      setDraftDialogOpen(false);
      history.push("/admin/invoices");
    } finally {
      setDraftSaving(false);
    }
  };

  // ── Load categories on mount ─────────────────────────────────────────────
  React.useEffect(() => {
    gql(`query{productCategories{id name}}`)
      .then(({ data }) => setCategories(data?.productCategories || []));
  }, []);

  // ── Load draft invoice when resuming ─────────────────────────────────────
  React.useEffect(() => {
    if (!draftId) return;
    setDraftLoading(true);
    Promise.all([
      gql(
        `query Q($id:String!){getInvoice(id:$id){id status note subtotal discount surcharges deliveryFee total paid cash card transfer wallet carrier deliveryNote receiverName receiverPhone receiverAddress receiverProvince receiverWard weight length width height customer{id customerNumber name phone1 address currentDebitAmount bank bankAccountNumber}}}`,
        { id: draftId }
      ),
      gql(
        `query Q($id:String!){getInvoiceDetails(invoiceId:$id){productId productNumber productName barcode brand unit productNote quantity price discountPercent discount salePrice total}}`,
        { id: draftId }
      ),
    ]).then(([invRes, detailRes]) => {
      const inv = invRes.data?.getInvoice;
      const details = detailRes.data?.getInvoiceDetails || [];
      if (!inv || inv.status !== "Draft") {
        history.push(`/admin/invoices/${draftId}`);
        return;
      }
      if (inv.customer) {
        setCustomer(inv.customer);
        setCustomerSearch(inv.customer.name);
      }
      setInvoiceDiscount(Number(inv.discount) || 0);
      setSurcharge(Number(inv.surcharges) || 0);
      setShippingCost(Number(inv.deliveryFee) || 0);
      setInvoiceNote(inv.note || "");
      if (inv.receiverName) {
        setIsDelivery(true);
        setReceiverName(inv.receiverName || "");
        setReceiverPhone(inv.receiverPhone || "");
        setReceiverAddress(inv.receiverAddress || "");
        setReceiverProvince(inv.receiverProvince || "");
        setReceiverWard(inv.receiverWard || "");
        setCarrier(inv.carrier || "");
        setCourierNote(inv.deliveryNote || "");
        if (inv.weight) setWeightGrams(Math.round(Number(inv.weight) * 1000));
        if (inv.length) setDimL(Number(inv.length));
        if (inv.width) setDimW(Number(inv.width));
        if (inv.height) setDimH(Number(inv.height));
      }
      if (details.length > 0) {
        setLines(details.map((d) => ({
          product: {
            id: d.productId || `manual-${d.productName}`,
            name: d.productName,
            productNumber: d.productNumber,
            barcode: d.barcode,
            brand: d.brand ? { name: d.brand } : null,
            unit: d.unit,
            sellingPrice: d.salePrice,
          },
          qty: Number(d.quantity),
          price: Number(d.price),
          salePrice: Number(d.salePrice),
          discount: Number(d.discount) || 0,
          discountPercent: Number(d.discountPercent) || 0,
          productNote: d.productNote || "",
        })));
      }
    }).finally(() => setDraftLoading(false));
  }, [draftId]); // eslint-disable-line

  // ── Pre-select customer from query params ─────────────────────────────────
  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const customerId = params.get("customerId");
    if (!customerId) return;
    gql(
      `query Q($s:String){customersWithPagination(filter:{page:1,pageSize:1,search:$s}){data{id customerNumber name phone1 address currentDebitAmount bank bankAccountNumber}}}`,
      { s: params.get("customerName") || "" }
    ).then(({ data }) => {
      const found = (data?.customersWithPagination?.data || []).find((c) => c.id === customerId);
      if (found) {
        setCustomer(found);
        setCustomerSearch(found.name);
      }
    });
  }, [location.search]);

  // ── Pre-select product from query params ─────────────────────────────────
  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const productId = params.get("productId");
    if (!productId) return;
    gql(
      `query Q($id:String!){getProduct(id:$id){id productNumber name sellingPrice costPrice onHand customerOrdered unit barcode brand{name} category{id name}}}`,
      { id: productId }
    ).then(({ data }) => {
      const p = data?.getProduct;
      if (!p) return;
      const sp = p.sellingPrice || 0;
      setLines((prev) => {
        if (prev.some((l) => l.product.id === p.id)) return prev;
        return [...prev, { product: p, qty: 1, price: sp, salePrice: sp, discount: 0, discountPercent: 0, productNote: "" }];
      });
    });
  }, [location.search]);

  // ── Load products ────────────────────────────────────────────────────────
  const loadProducts = React.useCallback((search, catId) => {
    setProductLoading(true);
    gql(`query Q($f:ProductFilterDto!){productsWithPagination(filter:$f){data{id productNumber name sellingPrice costPrice onHand customerOrdered unit barcode brand{name} category{id name}}}}`,
      { f: { page: 1, pageSize: 60, productName: search || undefined, categoryId: catId || undefined } })
      .then(({ data }) => setProductResults(data?.productsWithPagination?.data || []))
      .finally(() => setProductLoading(false));
  }, []);

  React.useEffect(() => { loadProducts("", ""); }, [loadProducts]);

  // ── Customer search ──────────────────────────────────────────────────────
  const handleCustomerSearch = (val) => {
    setCustomerSearch(val);
    clearTimeout(custDebounce.current);
    if (!val) { setCustomerResults([]); setShowCustDrop(false); return; }
    custDebounce.current = setTimeout(() => {
      gql(`query Q($s:String){customersWithPagination(filter:{page:1,pageSize:8,search:$s}){data{id customerNumber name phone1 address currentDebitAmount bank bankAccountNumber}}}`,
        { s: val })
        .then(({ data }) => {
          setCustomerResults(data?.customersWithPagination?.data || []);
          setShowCustDrop(true);
        });
    }, 300);
  };

  const selectCustomer = (c) => {
    setCustomer(c);
    setCustomerSearch(c.name);
    setShowCustDrop(false);
    setCustomerResults([]);
  };

  const handleSaveBank = () => {
    if (!customer) return;
    setBankSaving(true);
    gql(
      `mutation M($data:CreateCustomerDto!){createOrUpdateCustomer(data:$data)}`,
      { data: { id: customer.id, name: customer.name, bank: bankForm.bank, bankAccountNumber: bankForm.bankAccountNumber } }
    ).then(({ data, errors }) => {
      if (!errors && data?.createOrUpdateCustomer) {
        setCustomer((c) => ({ ...c, bank: bankForm.bank, bankAccountNumber: bankForm.bankAccountNumber }));
        setBankDialogOpen(false);
      }
    }).finally(() => setBankSaving(false));
  };

  const clearCustomer = () => {
    setCustomer(null);
    setCustomerSearch("");
  };

  // ── Product search ───────────────────────────────────────────────────────
  const handleProductSearch = (val) => {
    setProductSearch(val);
    clearTimeout(prodDebounce.current);
    prodDebounce.current = setTimeout(() => loadProducts(val, categoryId), 350);
  };

  const handleCategoryChange = (catId) => {
    setCategoryId(catId);
    loadProducts(productSearch, catId);
  };

  // ── Product select/deselect ──────────────────────────────────────────────
  const toggleProduct = (product) => {
    setLines((prev) => {
      const idx = prev.findIndex((l) => l.product.id === product.id);
      if (idx >= 0) {
        // Remove
        return prev.filter((_, i) => i !== idx);
      }
      // Add
      const sp = product.sellingPrice || 0;
      return [...prev, {
        product,
        qty: 1,
        price: sp,
        salePrice: sp,
        discount: 0,
        discountPercent: 0,
        productNote: "",
      }];
    });
  };

  const isSelected = (productId) => lines.some((l) => l.product.id === productId);
  const getLineQty = (productId) => {
    const l = lines.find((l) => l.product.id === productId);
    return l ? l.qty : 0;
  };

  // ── Step 2 line editing ──────────────────────────────────────────────────
  const updateLine = (index, updates) => {
    setLines((prev) => prev.map((l, i) => i === index ? { ...l, ...updates } : l));
  };

  const removeLine = (index) => {
    setLines((prev) => prev.filter((_, i) => i !== index));
  };

  // ── Pre-fill delivery from customer ─────────────────────────────────────
  const enterDeliveryStep = () => {
    if (customer) {
      setReceiverName((prev) => prev || customer.name || "");
      setReceiverPhone((prev) => prev || customer.phone1 || "");
      setReceiverAddress((prev) => prev || customer.address || "");
    }
    setStep(2);
  };

  // ── Financials ───────────────────────────────────────────────────────────
  const subtotal = lines.reduce((sum, l) => sum + (l.qty || 1) * (l.salePrice || 0), 0);
  const total = Math.max(0, subtotal - (invoiceDiscount || 0) + (surcharge || 0) + (shippingCost || 0));

  React.useEffect(() => {
    setCustomerPay(total);
  }, [total]);

  // ── Step 3: Complete ─────────────────────────────────────────────────────
  const handleComplete = async () => {
    if (lines.length === 0) return;
    setSubmitting(true);
    try {
      const payFields = { cash: 0, card: 0, transfer: 0, wallet: 0 };
      if (payMethod === "cash") payFields.cash = customerPay;
      else if (payMethod === "card") payFields.card = customerPay;
      else if (payMethod === "transfer") payFields.transfer = customerPay;
      else if (payMethod === "wallet") payFields.wallet = customerPay;

      const input = {
        customerId: customer?.id || undefined,
        subtotal,
        discount: invoiceDiscount || 0,
        surcharges: surcharge || 0,
        deliveryFee: shippingCost || 0,
        note: invoiceNote || undefined,
        total,
        paid: customerPay,
        ...payFields,
        // Delivery
        ...(isDelivery ? {
          carrier: carrier || undefined,
          deliveryNote: courierNote || undefined,
          receiverName: receiverName || undefined,
          receiverPhone: receiverPhone || undefined,
          receiverAddress: receiverAddress || undefined,
          receiverProvince: receiverProvince || undefined,
          receiverWard: receiverWard || undefined,
          weight: weightGrams ? weightGrams / 1000 : undefined,
          length: dimL || undefined,
          width: dimW || undefined,
          height: dimH || undefined,
        } : {}),
        lines: lines.map((l) => ({
          productId: l.product.id?.startsWith?.("manual-") ? undefined : l.product.id,
          productNumber: l.product.productNumber,
          productName: l.product.name,
          barcode: l.product.barcode,
          brand: l.product.brand?.name,
          unit: l.product.unit,
          productNote: l.productNote || undefined,
          quantity: l.qty,
          price: l.price,
          discountPercent: l.discountPercent || 0,
          discount: l.discount || 0,
          salePrice: l.salePrice,
          total: l.qty * l.salePrice,
        })),
      };

      const { data, errors } = draftId
        ? await gql(
            `mutation M($id:String!,$input:CreateInvoiceDto!){updateDraftInvoice(id:$id,input:$input){id invoiceNumber invoiceDate subtotal discount surcharges deliveryFee total paid note}}`,
            { id: draftId, input }
          )
        : await gql(
            `mutation M($input:CreateInvoiceDto!){createInvoice(input:$input){id invoiceNumber invoiceDate subtotal discount surcharges deliveryFee total paid note}}`,
            { input }
          );

      if (errors) { alert(errors[0].message); return; }

      const invoice = draftId ? data.updateDraftInvoice : data.createInvoice;
      setSuccessMsg(`Invoice ${invoice.invoiceNumber} ${draftId ? "saved!" : "created!"}`);

      // Print
      printInvoice(invoice, customer, lines.map((l) => ({
        productName: l.product.name,
        salePrice: l.salePrice,
        quantity: l.qty,
        total: l.qty * l.salePrice,
      })));

      // Unblock navigation then redirect
      setCompleted(true);
      setTimeout(() => history.push("/admin/invoices"), 1500);
    } finally {
      setSubmitting(false);
    }
  };

  // ── Render ───────────────────────────────────────────────────────────────

  const stepLabels = ["Select customer & products", "Review & edit lines", "Delivery", "Payment & complete"];

  return (
    <>
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <CheckCircle />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>{draftId ? "Resume Invoice" : "New Invoice"}</h4>
          </CardHeader>
          <CardBody>
            {/* Back link */}
            <div style={{ marginBottom: "8px" }}>
              <IconButton size="small" onClick={() => history.push("/admin/invoices")}>
                <ArrowBack fontSize="small" />
              </IconButton>
              <span style={{ fontSize: "13px", color: "#666", marginLeft: "4px" }}>Back to Invoices</span>
            </div>

            {draftLoading && (
              <div style={{ display: "flex", justifyContent: "center", padding: "40px" }}>
                <CircularProgress />
              </div>
            )}
            {/* Stepper */}
            {!draftLoading && (<div>
            <Stepper activeStep={step} style={{ padding: "12px 0 4px" }}>
              {stepLabels.map((label) => (
                <Step key={label}><StepLabel>{label}</StepLabel></Step>
              ))}
            </Stepper>

            {successMsg && (
              <div style={{ padding: "10px 16px", backgroundColor: "#e8f5e9", color: "#2e7d32", borderRadius: "6px", marginBottom: "10px", fontWeight: 600 }}>
                ✓ {successMsg}
              </div>
            )}

            {/* ── STEP 1 ── */}
            {step === 0 && (
              <div className={custom.stepContent}>
                {/* Customer search */}
                <div style={{ marginBottom: "16px" }}>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: "#555", marginBottom: "6px" }}>Customer</div>
                  {customer ? (
                    <div className={custom.selectedCustomer}>
                      <span style={{ fontWeight: 600 }}>{customer.name}</span>
                      {customer.phone1 && <span style={{ color: "#888", fontSize: "13px" }}>{customer.phone1}</span>}
                      {customer.currentDebitAmount > 0 && (
                        <span className={custom.debtBadge}>Debt: {formatNum(customer.currentDebitAmount)}</span>
                      )}
                      <IconButton size="small" onClick={clearCustomer} style={{ marginLeft: "auto" }}>
                        <span style={{ fontSize: "16px", color: "#888" }}>✕</span>
                      </IconButton>
                    </div>
                  ) : (
                    <div style={{ position: "relative", maxWidth: "400px" }}>
                      <div className={custom.searchBox}>
                        <Search style={{ color: "#aaa", marginRight: "6px", fontSize: "18px" }} />
                        <InputBase
                          placeholder="Search customer by name or phone..."
                          value={customerSearch}
                          onChange={(e) => handleCustomerSearch(e.target.value)}
                          onFocus={() => { if (customerResults.length) setShowCustDrop(true); }}
                          onBlur={() => setTimeout(() => setShowCustDrop(false), 200)}
                          style={{ fontSize: "14px", flex: 1 }}
                        />
                      </div>
                      {showCustDrop && customerResults.length > 0 && (
                        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 100, backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "4px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)" }}>
                          {customerResults.map((c) => (
                            <div key={c.id} className={custom.customerResult}
                              onMouseDown={() => selectCustomer(c)}>
                              <div>
                                <div style={{ fontWeight: 600, fontSize: "13px" }}>{c.name}</div>
                                <div style={{ fontSize: "12px", color: "#888" }}>{c.customerNumber} {c.phone1 && `· ${c.phone1}`}</div>
                              </div>
                              {c.currentDebitAmount > 0 && (
                                <span className={custom.debtBadge}>Debt: {formatNum(c.currentDebitAmount)}</span>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Product search + category filter */}
                <div style={{ fontSize: "13px", fontWeight: 600, color: "#555", marginBottom: "6px" }}>
                  Products
                  {lines.length > 0 && <span style={{ marginLeft: "10px", fontSize: "12px", color: "#1976d2", fontWeight: 400 }}>{lines.length} selected</span>}
                </div>
                <div style={{ display: "flex", gap: "10px", marginBottom: "10px", alignItems: "center" }}>
                  <div className={custom.searchBox}>
                    <Search style={{ color: "#aaa", marginRight: "6px", fontSize: "18px" }} />
                    <InputBase
                      placeholder="Search product..."
                      value={productSearch}
                      onChange={(e) => handleProductSearch(e.target.value)}
                      style={{ fontSize: "14px", flex: 1 }}
                    />
                  </div>
                </div>

                {/* Category tabs */}
                <div className={custom.categoryTabs}>
                  <div className={`${custom.catTab} ${categoryId === "" ? custom.catTabActive : ""}`}
                    onClick={() => handleCategoryChange("")}>All</div>
                  {categories.map((c) => (
                    <div key={c.id}
                      className={`${custom.catTab} ${categoryId === c.id ? custom.catTabActive : ""}`}
                      onClick={() => handleCategoryChange(c.id)}>
                      {c.name}
                    </div>
                  ))}
                </div>

                {/* Product grid */}
                {productLoading ? (
                  <div style={{ textAlign: "center", padding: "20px" }}><CircularProgress size={28} /></div>
                ) : (
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))", gap: "8px" }}>
                    {productResults.map((p) => {
                      const selected = isSelected(p.id);
                      const qty = getLineQty(p.id);
                      const idx = parseInt(p.id, 10) % PLACEHOLDER_COLORS.length;
                      return (
                        <div key={p.id}
                          className={`${custom.productCard} ${selected ? custom.productCardSelected : ""}`}
                          onClick={() => toggleProduct(p)}>
                          {selected && <div className={custom.qtyBadge}>{qty}</div>}
                          <div className={custom.productImg} style={{ backgroundColor: PLACEHOLDER_COLORS[idx] }}>🛍</div>
                          <div className={custom.productName}>{p.name.toUpperCase()}</div>
                          <div className={custom.productPrice}>{formatNum(p.sellingPrice)}</div>
                        </div>
                      );
                    })}
                    {productResults.length === 0 && !productLoading && (
                      <p style={{ color: "#999", gridColumn: "1/-1", textAlign: "center" }}>No products found</p>
                    )}
                  </div>
                )}

                <div className={custom.navBtns}>
                  <Button color="rose" disabled={lines.length === 0}
                    onClick={() => setStep(1)}>
                    Next → ({lines.length} items)
                  </Button>
                </div>
              </div>
            )}

            {/* ── STEP 2 ── */}
            {step === 1 && (
              <div className={custom.stepContent}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: "#555" }}>
                    {lines.length} product{lines.length !== 1 ? "s" : ""}
                  </div>
                  <div style={{ fontSize: "13px", fontWeight: 700, color: "#1565c0" }}>
                    Subtotal: {formatNum(subtotal)}
                  </div>
                </div>

                {/* Header */}
                <div style={{ display: "flex", gap: "10px", padding: "6px 12px", backgroundColor: "#f5f5f5", borderRadius: "4px", fontSize: "12px", color: "#888", marginBottom: "4px" }}>
                  <div style={{ width: "32px" }}></div>
                  <div style={{ width: "20px" }}>#</div>
                  <div style={{ flex: 1 }}>Product</div>
                  <div style={{ minWidth: "80px", textAlign: "right" }}>Price</div>
                  <div style={{ minWidth: "80px", textAlign: "right" }}>Total</div>
                  <div style={{ width: "50px" }}></div>
                  <div style={{ width: "32px" }}></div>
                </div>

                {lines.map((line, i) => (
                  <ProductLineItem
                    key={line.product.id}
                    line={line}
                    index={i}
                    customerId={customer?.id}
                    onQtyChange={(qty) => updateLine(i, { qty })}
                    onLineChange={(updates) => updateLine(i, updates)}
                    onRemove={() => removeLine(i)}
                    classes={classes}
                  />
                ))}

                {lines.length === 0 && (
                  <p style={{ textAlign: "center", color: "#999", padding: "20px" }}>
                    No products selected. Go back and add products.
                  </p>
                )}

                <div className={custom.navBtns}>
                  <Button onClick={() => setStep(0)}>← Back</Button>
                  <Button color="rose" disabled={lines.length === 0} onClick={enterDeliveryStep}>
                    Next →
                  </Button>
                </div>
              </div>
            )}

            {/* ── STEP 3 — DELIVERY ── */}
            {step === 2 && (
              <div className={custom.stepContent}>
                <div style={{ maxWidth: "520px" }}>
                  {/* Delivery toggle */}
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
                    <span style={{ fontSize: "14px", fontWeight: 600 }}>Delivery order?</span>
                    <div onClick={() => setIsDelivery(!isDelivery)}
                      style={{ width: "44px", height: "24px", borderRadius: "12px", border: "none",
                        backgroundColor: isDelivery ? "#1976d2" : "#ccc", cursor: "pointer",
                        position: "relative", transition: "background 0.2s", flexShrink: 0 }}>
                      <span style={{ position: "absolute", top: "2px", left: isDelivery ? "22px" : "2px",
                        width: "20px", height: "20px", borderRadius: "50%", backgroundColor: "#fff",
                        transition: "left 0.2s", display: "block", boxShadow: "0 1px 3px rgba(0,0,0,0.3)" }} />
                    </div>
                  </div>

                  {!isDelivery && (
                    <div style={{ padding: "20px", textAlign: "center", color: "#aaa", fontSize: "14px",
                      border: "2px dashed #e0e0e0", borderRadius: "8px", marginBottom: "16px" }}>
                      Walk-in / Pickup — no delivery needed
                    </div>
                  )}

                  {isDelivery && (
                    <>
                      {/* Carrier card */}
                      <div style={{ border: "1px solid #e0e0e0", borderRadius: "8px", marginBottom: "12px", overflow: "hidden" }}>
                        <div style={{ display: "flex", alignItems: "center", padding: "10px 14px", gap: "10px", backgroundColor: "#fafafa", borderBottom: "1px solid #f0f0f0" }}>
                          <span style={{ fontSize: "18px" }}>📍</span>
                          <input
                            style={{ flex: 1, border: "none", outline: "none", fontSize: "14px", fontWeight: 600, backgroundColor: "transparent" }}
                            placeholder="Carrier name..."
                            value={carrier}
                            onChange={(e) => setCarrier(e.target.value)} />
                          <input
                            style={{ width: "130px", border: "none", outline: "none", fontSize: "13px", backgroundColor: "transparent", textAlign: "right", color: "#555" }}
                            placeholder="Carrier phone..."
                            value={carrierPhone}
                            onChange={(e) => setCarrierPhone(e.target.value)} />
                        </div>
                      </div>

                      {/* Receiver info */}
                      <div style={{ border: "1px solid #e0e0e0", borderRadius: "8px", marginBottom: "12px", overflow: "hidden" }}>
                        <div style={{ padding: "10px 14px", borderBottom: "1px solid #f0f0f0" }}>
                          <div style={{ fontSize: "11px", color: "#888", marginBottom: "4px" }}>Receiver name</div>
                          <input style={{ width: "100%", border: "none", outline: "none", fontSize: "14px", fontWeight: 600 }}
                            placeholder="Receiver name..."
                            value={receiverName}
                            onChange={(e) => setReceiverName(e.target.value)} />
                        </div>
                        <div style={{ padding: "10px 14px", borderBottom: "1px solid #f0f0f0" }}>
                          <div style={{ fontSize: "11px", color: "#888", marginBottom: "4px" }}>Phone</div>
                          <input style={{ width: "100%", border: "none", outline: "none", fontSize: "14px" }}
                            placeholder="Phone number..."
                            value={receiverPhone}
                            onChange={(e) => setReceiverPhone(e.target.value)} />
                        </div>
                        <div style={{ padding: "10px 14px", borderBottom: "1px solid #f0f0f0" }}>
                          <div style={{ fontSize: "11px", color: "#888", marginBottom: "4px" }}>Address</div>
                          <input style={{ width: "100%", border: "none", outline: "none", fontSize: "14px" }}
                            placeholder="Street address..."
                            value={receiverAddress}
                            onChange={(e) => setReceiverAddress(e.target.value)} />
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={{ flex: 1, padding: "10px 14px", borderRight: "1px solid #f0f0f0" }}>
                            <div style={{ fontSize: "11px", color: "#888", marginBottom: "4px" }}>Khu vực</div>
                            <input style={{ width: "100%", border: "none", outline: "none", fontSize: "14px" }}
                              placeholder="Khu vực..."
                              value={receiverProvince}
                              onChange={(e) => setReceiverProvince(e.target.value)} />
                          </div>
                          <div style={{ flex: 1, padding: "10px 14px" }}>
                            <div style={{ fontSize: "11px", color: "#888", marginBottom: "4px" }}>Phường/Xã</div>
                            <input style={{ width: "100%", border: "none", outline: "none", fontSize: "14px" }}
                              placeholder="Phường/Xã..."
                              value={receiverWard}
                              onChange={(e) => setReceiverWard(e.target.value)} />
                          </div>
                        </div>
                      </div>

                      {/* Package info */}
                      <div style={{ border: "1px solid #e0e0e0", borderRadius: "8px", marginBottom: "12px", overflow: "hidden" }}>
                        {/* Package count */}
                        <div style={{ display: "flex", alignItems: "center", padding: "10px 14px", gap: "10px", borderBottom: "1px solid #f0f0f0" }}>
                          <span style={{ fontSize: "18px" }}>📦</span>
                          <div className={custom.qtyStepper} style={{ margin: 0 }}>
                            <div className={custom.qtyBtn} onClick={() => setPackages(Math.max(1, packages - 1))}>−</div>
                            <span style={{ fontSize: "14px", fontWeight: 600, minWidth: "32px", textAlign: "center" }}>{packages}</span>
                            <div className={custom.qtyBtn} onClick={() => setPackages(packages + 1)}>+</div>
                          </div>
                          <span style={{ fontSize: "14px", color: "#555" }}>kiện</span>
                        </div>

                        {/* Weight & dimensions */}
                        <div style={{ display: "flex", alignItems: "center", padding: "10px 14px", gap: "8px", flexWrap: "wrap", borderBottom: "1px solid #f0f0f0" }}>
                          <input type="number" min="1"
                            style={{ width: "70px", border: "1px solid #e0e0e0", borderRadius: "4px", padding: "4px 8px", fontSize: "14px", textAlign: "right", outline: "none" }}
                            value={weightGrams}
                            onChange={(e) => setWeightGrams(parseInt(e.target.value) || 0)} />
                          <span style={{ fontSize: "13px", color: "#555" }}>gram</span>
                          <span style={{ color: "#ddd", margin: "0 4px" }}>|</span>
                          <input type="number" min="1"
                            style={{ width: "48px", border: "1px solid #e0e0e0", borderRadius: "4px", padding: "4px 6px", fontSize: "14px", textAlign: "center", outline: "none" }}
                            value={dimL} onChange={(e) => setDimL(parseInt(e.target.value) || 1)} />
                          <span style={{ fontSize: "13px", color: "#555" }}>×</span>
                          <input type="number" min="1"
                            style={{ width: "48px", border: "1px solid #e0e0e0", borderRadius: "4px", padding: "4px 6px", fontSize: "14px", textAlign: "center", outline: "none" }}
                            value={dimW} onChange={(e) => setDimW(parseInt(e.target.value) || 1)} />
                          <span style={{ fontSize: "13px", color: "#555" }}>×</span>
                          <input type="number" min="1"
                            style={{ width: "48px", border: "1px solid #e0e0e0", borderRadius: "4px", padding: "4px 6px", fontSize: "14px", textAlign: "center", outline: "none" }}
                            value={dimH} onChange={(e) => setDimH(parseInt(e.target.value) || 1)} />
                          <span style={{ fontSize: "13px", color: "#555" }}>cm</span>
                        </div>

                        {/* Courier note */}
                        <div style={{ display: "flex", alignItems: "center", padding: "10px 14px", gap: "8px" }}>
                          <span style={{ fontSize: "16px" }}>✏️</span>
                          <input style={{ flex: 1, border: "none", outline: "none", fontSize: "13px", color: "#555" }}
                            placeholder="Ghi chú cho bưu tá..."
                            value={courierNote}
                            onChange={(e) => setCourierNote(e.target.value)} />
                        </div>
                      </div>
                    </>
                  )}

                  <div className={custom.navBtns}>
                    <Button onClick={() => setStep(1)}>← Back</Button>
                    <Button color="rose" onClick={() => setStep(3)}>Next →</Button>
                  </div>
                </div>
              </div>
            )}

            {/* ── STEP 4 — PAYMENT ── */}
            {step === 3 && (
              <div className={custom.stepContent}>
                <div style={{ maxWidth: "480px", margin: "0 auto" }}>
                  {/* Customer info */}
                  {customer && (
                    <div style={{ padding: "12px 0", borderBottom: "1px solid #eee", marginBottom: "12px" }}>
                      <div style={{ fontWeight: 700, fontSize: "16px" }}>{customer.name}</div>
                      {customer.phone1 && <div style={{ color: "#888", fontSize: "13px" }}>{customer.phone1}</div>}
                      {customer.currentDebitAmount > 0 && (
                        <span className={custom.debtBadge} style={{ marginTop: "4px", display: "inline-block" }}>
                          Debt: {formatNum(customer.currentDebitAmount)}
                        </span>
                      )}
                    </div>
                  )}

                  {/* Summary */}
                  <div>
                    <div className={custom.summaryRow}>
                      <span>Sub-total</span>
                      <span>{lines.length} items · {formatNum(subtotal)}</span>
                    </div>

                    <div className={custom.summaryRow}>
                      <span>Discount</span>
                      <input type="number" style={{ border: "none", borderBottom: "1px solid #ccc", outline: "none", fontSize: "14px", textAlign: "right", width: "120px" }}
                        value={invoiceDiscount || 0}
                        onChange={(e) => setInvoiceDiscount(parseFloat(e.target.value) || 0)} />
                    </div>

                    <div className={custom.summaryRow}>
                      <span>Surcharge</span>
                      <input type="number" style={{ border: "none", borderBottom: "1px solid #ccc", outline: "none", fontSize: "14px", textAlign: "right", width: "120px" }}
                        value={surcharge || 0}
                        onChange={(e) => setSurcharge(parseFloat(e.target.value) || 0)} />
                    </div>

                    <div className={custom.summaryRow}>
                      <span>Shipping cost</span>
                      <input type="number" style={{ border: "none", borderBottom: "1px solid #ccc", outline: "none", fontSize: "14px", textAlign: "right", width: "120px" }}
                        value={shippingCost || 0}
                        onChange={(e) => setShippingCost(parseFloat(e.target.value) || 0)} />
                    </div>

                    <div className={custom.summaryTotal}>
                      <span>Total</span>
                      <span>{formatNum(total)}</span>
                    </div>

                  </div>

                  {/* Payment method */}
                  <div style={{ marginTop: "14px" }}>
                    <RadioGroup row value={payMethod} onChange={(e) => setPayMethod(e.target.value)}>
                      <FormControlLabel value="cash" control={<Radio color="primary" />} label="Cash" />
                      <FormControlLabel value="transfer" control={<Radio color="primary" />} label="Bank transfer" />
                      <FormControlLabel value="card" control={<Radio color="primary" />} label="Card" />
                      <FormControlLabel value="wallet" control={<Radio color="primary" />} label="Wallet" />
                    </RadioGroup>
                  </div>

                  {/* Bank info — only for Bank transfer */}
                  {payMethod === "transfer" && (
                    <div style={{ margin: "10px 0", padding: "10px 14px", borderRadius: "8px", backgroundColor: "#f5f5f5", fontSize: "13px" }}>
                      {!customer ? (
                        <span style={{ color: "#aaa" }}>Select a customer to see bank info</span>
                      ) : customer.bank || customer.bankAccountNumber ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                          <div>
                            <div style={{ color: "#888", fontSize: "11px", marginBottom: "2px" }}>BANK</div>
                            <div style={{ fontWeight: 600, color: "#333" }}>{customer.bank || "—"}</div>
                          </div>
                          <div>
                            <div style={{ color: "#888", fontSize: "11px", marginBottom: "2px" }}>ACCOUNT NUMBER</div>
                            <div style={{ fontWeight: 600, color: "#333" }}>{customer.bankAccountNumber || "—"}</div>
                          </div>
                          <button
                            onClick={() => { setBankForm({ bank: customer.bank || "", bankAccountNumber: customer.bankAccountNumber || "" }); setBankDialogOpen(true); }}
                            style={{ marginLeft: "auto", fontSize: "12px", padding: "4px 10px", border: "1px solid #1976d2", borderRadius: "4px", backgroundColor: "#fff", color: "#1976d2", cursor: "pointer" }}>
                            Edit
                          </button>
                        </div>
                      ) : (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <span style={{ color: "#e65100" }}>No bank info on file for this customer</span>
                          <button
                            onClick={() => { setBankForm({ bank: "", bankAccountNumber: "" }); setBankDialogOpen(true); }}
                            style={{ fontSize: "12px", padding: "4px 12px", border: "1px solid #e65100", borderRadius: "4px", backgroundColor: "#fff", color: "#e65100", cursor: "pointer", fontWeight: 600 }}>
                            Quick update
                          </button>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Invoice note */}
                  <div style={{ marginTop: "12px" }}>
                    <div style={{ fontSize: "12px", color: "#888", marginBottom: "4px" }}>Note</div>
                    <textarea
                      value={invoiceNote}
                      onChange={(e) => setInvoiceNote(e.target.value)}
                      placeholder="Invoice note..."
                      style={{ width: "100%", border: "1px solid #ccc", borderRadius: "4px", padding: "6px 8px", fontSize: "13px", resize: "vertical", minHeight: "56px", fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
                    />
                  </div>

                  <div className={custom.navBtns} style={{ marginTop: "24px" }}>
                    <Button onClick={() => setStep(2)}>← Back</Button>
                    <Button color="success" disabled={submitting || lines.length === 0} onClick={handleComplete}>
                      {submitting ? <CircularProgress size={18} style={{ color: "#fff" }} /> : "✓ Complete"}
                    </Button>
                  </div>
                </div>
              </div>
            )}
            </div>)}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>

    {/* Bank info quick-update dialog */}
    <Dialog open={bankDialogOpen} onClose={() => setBankDialogOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Update bank info — {customer?.name}</DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", flexDirection: "column", gap: "14px", paddingTop: "8px" }}>
          <div>
            <div style={{ fontSize: "12px", color: "#888", marginBottom: "4px" }}>Bank name</div>
            <select
              autoFocus
              value={bankForm.bank}
              onChange={(e) => setBankForm((f) => ({ ...f, bank: e.target.value }))}
              style={{ width: "100%", border: "1px solid #ccc", borderRadius: "6px", padding: "8px 10px", fontSize: "14px", outline: "none", boxSizing: "border-box", backgroundColor: "#fff" }}>
              <option value="">— Select bank —</option>
              {VN_BANKS.map((b) => (
                <option key={b} value={b}>{b}</option>
              ))}
            </select>
          </div>
          <div>
            <div style={{ fontSize: "12px", color: "#888", marginBottom: "4px" }}>Account number</div>
            <input
              value={bankForm.bankAccountNumber}
              onChange={(e) => setBankForm((f) => ({ ...f, bankAccountNumber: e.target.value }))}
              placeholder="Account number..."
              style={{ width: "100%", border: "1px solid #ccc", borderRadius: "6px", padding: "8px 10px", fontSize: "14px", outline: "none", boxSizing: "border-box" }}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <button onClick={() => setBankDialogOpen(false)}
          style={{ padding: "7px 18px", border: "1px solid #ccc", borderRadius: "6px", background: "#fff", cursor: "pointer", fontSize: "13px" }}>
          Cancel
        </button>
        <button onClick={handleSaveBank} disabled={bankSaving}
          style={{ padding: "7px 18px", border: "none", borderRadius: "6px", background: "#1976d2", color: "#fff", cursor: "pointer", fontSize: "13px", fontWeight: 600 }}>
          {bankSaving ? "Saving..." : "Save"}
        </button>
      </DialogActions>
    </Dialog>

    {/* Save draft dialog */}
    <Dialog open={draftDialogOpen} onClose={() => setDraftDialogOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Save as draft?</DialogTitle>
      <DialogContent>
        <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
          You have {lines.length} product{lines.length !== 1 ? "s" : ""} in this invoice.
          Do you want to save it as a draft before leaving?
        </p>
      </DialogContent>
      <DialogActions>
        <button onClick={() => setDraftDialogOpen(false)}
          style={{ padding: "7px 18px", border: "1px solid #ccc", borderRadius: "6px", background: "#fff", cursor: "pointer", fontSize: "13px" }}>
          Cancel
        </button>
        <button onClick={doNavigate}
          style={{ padding: "7px 18px", border: "1px solid #e53935", borderRadius: "6px", background: "#fff", color: "#e53935", cursor: "pointer", fontSize: "13px" }}>
          Don&apos;t save
        </button>
        <button onClick={handleSaveDraft} disabled={draftSaving}
          style={{ padding: "7px 18px", border: "none", borderRadius: "6px", background: "#1976d2", color: "#fff", cursor: "pointer", fontSize: "13px", fontWeight: 600 }}>
          {draftSaving ? "Saving..." : "Save draft"}
        </button>
      </DialogActions>
    </Dialog>
    </>
  );
}
